import React, { createContext, useContext } from 'react'
import { View, Text, TouchableOpacity, Image, Dimensions } from 'react-native'
import Benefits from './src/seeds/benefits.json'
import { FlashList } from '@shopify/flash-list'
import styles from './benefitsListStyles'
import BenefitContext from './BenefitContext'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { useFetchBenefits } from './hooks/useFetchBenefits'
import { placeholderGeneral } from '../customUtils/Constants'
import { Loader } from '../customUtils/Components/Loader'
import styless from './benefitsHistoryListStyles'
import styles3 from './benefitsHomeStyles3'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { LinearGradient } from 'expo-linear-gradient'
import { ScrollView } from 'react-native-gesture-handler'
import { isIOS, isAndroid } from '../../utils/platformUtils'

const { width, height } = Dimensions.get('window')

const BenefitCard = ({ points }) => {
    const { languageFile } = getLanguage()
    //console.log('🚀 ~ BenefitCard ~ points:', points)
    return (
        <LinearGradient
            style={styles3.container}
            colors={[theme.colors.linearGradientStart, theme.colors.linearGradientEnd]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
        >
            <View style={[styles3.feedbackAssetContainer]}>
                <Image style={[styles3.feedbackAsset]} source={require('../../../assets/benefitsPoints.png')} />
            </View>

            <View style={[styles3.levelKnowledgeBlock, styles3.alignStart]}>
                <View>
                    <View style={styles3.containerData}>
                        <Text style={styles3.title}>{languageFile.your_points}</Text>
                        <Text style={styles3.value}>{points}</Text>
                    </View>

                    <Text style={[styles3.subtitle]}>{languageFile.points_can_be_exchanged}</Text>
                </View>
            </View>
        </LinearGradient>
    )
}

const BenefitItem = ({ item }) => {
    // Usamos useContext para acceder al contexto
    const handleFunctionCall = useContext(BenefitContext)

    const handleClick = () => {
        // Llamada a la función del componente abuelo
        handleFunctionCall(item)
    }

    const { languageFile } = getLanguage()

    return (
        <View style={styles.benefitsModuleList}>
            <TouchableOpacity onPress={handleClick}>
                <View style={styles.benefitsContainerList}>
                    <View>
                        <Image style={styles.benefitImage} source={{ uri: item.cover_image ? item.cover_image : placeholderGeneral }} />
                    </View>
                    <View style={styles.textBlock}>
                        <Text style={styles.title} numberOfLines={1}>
                            {item.title}
                        </Text>
                        <View style={styles.pointsBlock}>
                            <Text style={styles.points}>
                                {item.points}
                                {languageFile.points}
                            </Text>
                            <Feather name='chevron-right' size={20} color={theme.colors.colorPrimary} />
                        </View>
                    </View>
                </View>
            </TouchableOpacity>
        </View>
    )
}

const BenefitsList = ({ points }) => {
    const { data, isLoading, reload, fetch_data, setIsLoading } = useFetchBenefits()
    //console.log('🚀 ~ BenefitsList ~ data:', data)
    const { languageFile } = getLanguage()

    return isLoading ? (
        <Loader />
    ) : (
        <>
            {data.length == 0 ? (
                <View style={styless.container}>
                    <Image style={styless.image} source={require('../../../assets/noBenefits.png')} />
                    <Text style={styless.title}>{languageFile.no_benefits}</Text>
                    <Text style={styless.description}>{languageFile.add_points}</Text>
                </View>
            ) : (
                <View style={styless.containerFlex}>
                    <ScrollView style={styless.containerFlex}>
                        {isIOS() && <View style={styless.viewHeight}></View>}
                        {isAndroid() && <View style={styless.viewHeight}></View>}
                        <FlashList
                            data={data}
                            horizontal={false}
                            keyExtractor={(item) => item._id}
                            numColumns={2}
                            showsHorizontalScrollIndicator={false}
                            renderItem={({ item: benefitItem }) => <BenefitItem item={benefitItem} />}
                        />
                    </ScrollView>
                </View>
            )}
        </>
    )
}

export default BenefitsList
